import { SET_AUTH_DATA, SET_AUTH_ERROR, SET_AUTH_LOADING, SIGNED_OUT } from "./types";
import { api } from "../App";


export const auth = (values) => async (dispatch, getState) => {
  dispatch({ type: SET_AUTH_LOADING, payload: true });
  // сбрасываем предыдущую ошибку авторизации перед новым запросом
  dispatch({ type: SET_AUTH_ERROR, payload: null });
  try {

    const response = await api.post('/monitoring_lms_cons/auth', values);
    dispatch({ type: SET_AUTH_DATA, payload: response.data });
    // на успешной авторизации ошибок быть не должно
    dispatch({ type: SET_AUTH_ERROR, payload: null });
  } catch (error) {
    // пробуем достать человеко‑читаемое сообщение об ошибке из ответа сервера
    const errorMessage =
      error?.response?.data?.detail ||
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      // запасной вариант, если сервер ничего не вернул
      'Ошибка авторизации. Проверьте логин и пароль.';
    console.log('errorMessage::: ', errorMessage);

    dispatch({ type: SET_AUTH_ERROR, payload: errorMessage });
  } finally {
    dispatch({ type: SET_AUTH_LOADING, payload: false });
  }
};

export const signOut = () => async (dispatch) => {
  dispatch({ type: SIGNED_OUT });
};